// extracted by mini-css-extract-plugin
export default {"componentCardMirror":"oAtDsWI2ELGV2ojq3mgJ"};